<template>

	<div class="content">
		<div class="content_head">

			<select v-model="areaID" v-if="$store.state.user.UserType==0" @change="selectArea">
				<option v-for="(i,index) in $store.state.area" :value="i.areaID">{{i.areaName}}</option>
			</select>
			<select v-model="ShopID" title="选择店铺" @change="getBooks" v-if="$store.state.user.UserType<=1">
				<option v-for="i in Shop" :value="i.ShopID">
					{{i.ShopName}}
				</option>
			</select>
			<input type="text" v-model="search" placeholder="书籍名称|书籍编号" @keypress.enter="getBooks" />
			<button type="button" @click="getBooks" class="button"> 查询</button>
			<hr style="margin: 1rem 0rem;" />
			<input type="text" @keypress.enter="moveBook" v-model="BooksNumCode" ref="booksCode"
				placeholder="扫描书籍二维码" />
			<button @click="moveBook()" :disabled="BooksNumCode.trim().length<8" class="button"
				:class="{'disabled':BooksNumCode.trim().length<8}"> 调入书籍</button>
		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th>书籍名称</th>
						<th>书籍编号</th>
						<th>当前位置</th>
						<th>书籍状态</th>
						<th>书籍备注</th>
						<th>调入时间</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(i,index) in books">
						<td>
							{{index+1+ (pageIndex-1)*pageRows}}
						</td>
						<td>
							{{i.BooksName}}
						</td>
						<td>
							{{i.BooksNumCode}}
						</td>

						<td>
							{{i.ShopName + i.CurrentPlace}}
						</td>
						<td>
							{{i.BooksSate | bookState}}
						</td>
						<td>
							{{i.BooksDesc}}
						</td>
						<td>
							{{$moment (i.beginDate).format('YYYY年MM月DD日')}}-<span class="red">
								{{ ($moment(new Date()).diff($moment(i.beginDate), 'days')+1) +'天'    }}
							</span>

						</td>


					</tr>
				</tbody>
			</table>
		</div>
		<div class="foot_pages">
			<span class="red">{{"合计:"+count+'册图书'}}</span>
			<button class="button" :class="{'disabled':up}" :disabled="up" @click="changePages('up')">上一页</button>
			<span>{{page}}</span>
			<select v-model="pageRows" @change="changePageRows">
				<option value="10">10/页</option>
				<option value="15">15/页</option>
				<option value="20">20/页</option>

			</select>
			<button class="button" :class="{'disabled':down}" :disabled="down" @click="changePages('down')">下一页</button>
		</div>

	</div>
</template>

<script>
	import j from './movebooks.js'
	export default j
</script>

<style scoped>
	.content_head input[type=text] {
		padding: .2rem !important;
	}
</style>
